exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.wind-profiler[data-v-bf10e072] {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 25rem;\r\n    max-height: 50vh;\r\n    padding: 0 1rem;\n}\n.wind-profiler-chart[data-v-bf10e072] {\r\n    flex: 1;\r\n    width: 100%;\r\n    height: 100%;\n}\r\n", ""]);

